// @flow

import * as React from 'react';
import styled from 'styled-components';

type Props = {
  id: string,
  checked: boolean,
  value: any,
  onChange: (newValue: string) => void,
  disabled?: boolean,
  children?: React.Node,
  tabIndex?: number,
};

const Tick = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  margin: 0.125rem;
  border-width: ${(props) =>
    props.checked === true ? '0.313rem' : '0.063rem'};
  border-style: solid;
  border-color: #009edd;
  border-radius: 50%;
  border-color: ${(props) =>
    props.disabled ? props.theme.disabledColor : props.theme.actionColor};
  cursor: ${(props) => (props.disabled ? null : 'pointer')};
  transition: border-width 0.2s linear;
  transition-property: border-width;
  transition-duration: 0.2s;
  transition-timing-function: linear;
  transition-delay: initial;
  float: left;
  background-color: ${(props) => props.theme.backgroundColor};
`;

const StyledRadioButton = styled.input`
  display: none;
`;

const RadioButtonLabel = styled.label`
  display: block;
  margin-left: 2.188rem;
  color: ${(props) =>
    props.disabled ? props.theme.disabledColor : props.theme.textColor};
`;

class RadioButton extends React.Component<Props> {
  handleChange = () => {
    const { onChange, disabled, checked, value } = this.props;

    if (!disabled) {
      if (checked === false) {
        onChange(value);
      }
    }
    //this.context.dbui.registerAnalyticsEvent(this.props.id);
  };

  render() {
    return (
      <div
        role="radio"
        aria-checked={this.props.checked}
        onClick={this.handleChange}
        tabIndex={
          this.props.tabIndex || this.props.tabIndex === 0
            ? this.props.tabIndex
            : undefined
        }
      >
        <StyledRadioButton
          id={this.props.id}
          type="radio"
          value={this.props.value}
          disabled={this.props.disabled}
        />
        <label htmlFor={this.props.id}>
          <Tick checked={this.props.checked} disabled={this.props.disabled} />
          <RadioButtonLabel disabled={this.props.disabled}>
            {this.props.children}
          </RadioButtonLabel>
        </label>
      </div>
    );
  }
}

export default RadioButton;
